<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">NIT</a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <router-link to="/" class="nav-link" aria-current="page"
              >Home</router-link
            >
          </li>
          <li class="nav-item">
            <router-link to="/marketing" class="nav-link">Marketing</router-link>
          </li>
          <!-- Kora migration tools (AB#81176), grouped so they don't take over the menu. -->
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" :class="{ active: koraAppActive }" href="#" role="button"
               data-bs-toggle="dropdown" aria-expanded="false">Kora App</a>
            <ul class="dropdown-menu">
              <li v-for="t in koraAppTools" :key="t.to">
                <router-link :to="t.to" class="dropdown-item" active-class="active">{{ t.label }}</router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item" v-if="!loggedIn">
            <a href="/login" class="nav-link">Login</a>
          </li>
          <li class="nav-item" v-else>
            <a href="/logout" class="nav-link">Log out</a>
          </li>
        </ul>
        <div class="text-center mt-3" v-if="loggedIn && userName">
          {{ userName }}
        </div>
      </div>
    </div>
  </nav>
  <div v-if="!loggedIn" class="text-center">
    <a href="login" class="btn btn-outline-dark">Please login</a>
  </div>
  <router-view v-if="loggedIn" />
</template>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
<script>
import usePromise from "@/composables/use-promise";
import { whoAmI } from "@/services/user.js";

export default {
  async mounted() {
    const { results, run } = usePromise(whoAmI);
    await run();

    this.userName = results?.value?.userDetails;
    this.loggedIn = results.value
      ? results.value.userRoles.includes("authenticated")
      : false;
  },
  computed: {
    // Highlight the menu when one of its pages is open.
    koraAppActive() {
      return this.koraAppTools.some((t) => this.$route.path === t.to);
    },
  },
  data() {
    return {
      koraAppTools: [
        { to: "/preflight", label: "Kora Pre-flight" },
        { to: "/kora-status", label: "Kora Status Check" },
        { to: "/oc-users", label: "OC Users" },
        { to: "/in-app-numbers", label: "In-App Numbers" },
      ],
      loggedIn: false,
      userName: null,
      account: null,
    };
  },
};
</script>

